import {debounce} from 'vue-debounce';
import Panzoom from '@panzoom/panzoom';
import Vue from '../main/vue';
import router from '../main/vue-routes';
import store from '../main/vue-store';
import {ready} from '../main/utils';
import VariationActions from '../products/components/VariationActions.vue';

ready(() => {
  if (document.getElementById('commerce-parts')) {
    new Vue({
      el: '#commerce-parts',
      comments: true,
      router,
      store,
      components: {
        'variation-actions': VariationActions
      },
      data() {
        return {
          loading: true,
          error: false,
          parts: [],
          filteredParts: [],
          query: null
        };
      },
      created() {
        const nid = document.getElementById('commerce-parts').dataset.nid;

        fetch(
          `/rest/part-grouping-parts/${nid}`,
          {headers: {'Content-Type': 'application/json'}}
        )
          .then(response => response.json())
          .then(res => {
            const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
            const resSorted = res.sort((a, b) => {
              if (a.diagram_label === '') return 1;
              if (b.diagram_label === '') return -1;
              return collator.compare(a.diagram_label, b.diagram_label);
            });

            this.parts = resSorted;
            this.filteredParts = this.parts;
            this.loading = false;
            this.error = false;
          })
          .catch(() => {
            this.parts = [];
            this.filteredParts = [];
            this.loading = false;
            this.error = true;
          });
      },
      mounted() {
        const img = document.querySelector('.parts-diagram-line-drawing figure');
        if (img) {
          const panzoom = Panzoom(img, {maxScale: 5});
          const zoomInButton = document.querySelector('.parts-diagram-zoom-in');
          const zoomOutButton = document.querySelector('.parts-diagram-zoom-out');
          const resetButton = document.querySelector('.parts-diagram-reset');
          const rangeInput = document.querySelector('.parts-diagram-zoom-range');

          zoomInButton.addEventListener('click', () => {
            panzoom.zoomIn();
            rangeInput.value = panzoom.getScale();
          });

          zoomOutButton.addEventListener('click', () => {
            panzoom.zoomOut();
            rangeInput.value = panzoom.getScale();
          });

          resetButton.addEventListener('click', () => {
            panzoom.reset();
            rangeInput.value = 1;
          });

          rangeInput.addEventListener('input', event => panzoom.zoom(event.target.value));
        }
      },
      watch: {
        query: debounce(function() {
          const query = this.query.toLowerCase();

          this.filteredParts = this.parts.filter(part =>
            part?.sku.toLowerCase().includes(query) ||
            part?.part_number.toLowerCase().includes(query) ||
            part?.part_type.toLowerCase().includes(query) ||
            part?.description.toLowerCase().includes(query)
          );

          this.loading = false;
        }, 1000)
      },
      methods: {
        getImage(part) {
          const variationImage = part?.variation_image;
          const productImage = part?.product_image;
          const image = variationImage || productImage;

          return image ? [{src: image, alt: `Product Image for ${part.sku}`}] : null;
        }
      }
    });
  }
});
